import axios from "./axios"
import * as Ford from "./generated/FordInterfaces"

export const postContact = (data: Ford.Contact & Ford.UtmQuery) =>
  axios.post<Ford.BooleanResponseWrapper>(`/api/contact`, data, { headers: {} })
